const data = [
    {
        id:"One",
        name:"అశ్వని",
        desc:"భరణి, కృత్తిక,మృగశిర, పుష్యమి, ఆశ్లేష, పుబ్బ, పూర్వాషాఢ, ఉత్తరాషాఢ,ఉత్తరాభాద్ర, రేవతి."
    },
    {
        id:"Two",
        name:"భరణి",
        desc:"అశ్వని,కృత్తిక, రోహిణి,ఆర్ద్ర, పునర్వసు, ఆశ్లేష, మఖ, ఉత్తర (ఉత్తరఫల్గుణి), స్వాతి, విశాఖ, మూల, ఉత్తరాషాఢ, శ్రవణము, రేవతి."
    },
    {
        id:"Three",
        name:"కృత్తిక",
        desc:"అశ్వని, భరణి, మృగశిర, పునర్వసు, పుష్యమి, పుబ్బ,చిత్త, అనూరాధ, మూల,ధనిష్ఠ, ఉత్తరాభాద్ర."

    },
    {
        id:"Four",
        name:"రోహిణి",
        desc:"భరణి, మృగశిర, ఆర్ద్ర, పుష్యమి, పుబ్బ (పూర్వఫల్గుణి), ఉత్తర (ఉత్తరఫల్గుణి), హస్త, చిత్త, అనూరాధ, జ్యేష్ట, పూర్వాషాఢ, ధనిష్ఠ, శతభిషము, ఉత్తరాభాద్ర, రేవతి."

    },
    {
        id:"Five",
        name:"మృగశిర",
        desc:"అశ్వని,కృత్తిక, రోహిణి, ఆర్ద్ర, పునర్వసు,మఖ,ఉత్తర (ఉత్తరఫల్గుణి), హస్త, స్వాతి, శ్రవణము, శతభిషము, పూర్వాభాద్ర,రేవతి."
    },
    {
        id:"Six",
        name:"ఆరుద్ర",
        desc:"భరణి, రోహిణి, మృగశిర, పుష్యమి, మఖ, పుబ్బ (పూర్వఫల్గుణి), హస్త, చిత్త, పూర్వాషాఢ, ఉత్తరాభాద్ర."
    },
    {
        id:"Seven",
        name:"పునర్వసు",
        desc:"భరణి, కృత్తిక,మృగశిర, ఆర్ద్ర, పుష్యమి,చిత్త, స్వాతి, అనూరాధ, పూర్వాషాఢ, శతభిషము, ఉత్తరాభాద్ర, రేవతి."
    },
    {
        id:"Eight",
        name:"పుష్యమి",
        desc:"అశ్వని, కృత్తిక, రోహిణి, పునర్వసు, ఆశ్లేష, ఉత్తర (ఉత్తరఫల్గుణి), హస్త, స్వాతి, విశాఖ, జ్యేష్ట, ఉత్తరాషాఢ2 3 4, పూర్వాభాద్ర 4 , రేవతి."
    },
    {
        id:"Nine",
        name:"ఆశ్లేష",
        desc:"అశ్వని, భరణి, పుష్యమి,హస్త, చిత్త, అనూరాధ, జ్యేష్ట, ధనిష్ఠ, ఉత్తరాభాద్ర."
    },
    {
        id:"Ten",
        name:"మఖ",
        desc:"అశ్వని, భరణి, మృగశిర, ఆర్ద్ర, పుష్యమి, పుబ్బ (పూర్వఫల్గుణి), చిత్త, అనూరాధ, పూర్వాషాఢ,ధనిష్ఠ 3 4 , శతభిషము."
    },
    {
        id:"Eleven",
        name:"పుబ్బ",
        desc:"అశ్వని, కృత్తిక, రోహిణి, ఆర్ద్ర, మఖ, ఉత్తర (ఉత్తరఫల్గుణి), హస్త, స్వాతి, విశాఖ, జ్యేష్ట, మూల, ఉత్తరాషాఢ, శతభిషము, పూర్వాభాద్ర, రేవతి."
    },
    {
        id:"Twelve",
        name:"ఉత్తర",
        desc:"భరణి, రోహిణి, మృగశిర, పుష్యమి, పుబ్బ (పూర్వఫల్గుణి), అనూరాధ, పూర్వాషాఢ, శ్రవణము, ఉత్తరాభాద్ర."
    },
    {
        id:"Thirteen",
        name:"హస్త",
        desc:"రోహిణి, మృగశిర, ఆర్ద్ర, పుష్యమి, ఆశ్లేష, పుబ్బ (పూర్వఫల్గుణి), చిత్త, స్వాతి, అనూరాధ, పూర్వాషాఢ, ఉత్తరాషాఢ, ధనిష్ఠ, ఉత్తరాభాద్ర, రేవతి."
    },
    {
        id:"Fourteen",
        name:"చిత్త",
        desc:"కృత్తిక, రోహిణి, ఆర్ద్ర, పునర్వసు, ఆశ్లేష, మఖ, హస్త, స్వాతి, విశాఖ, జ్యేష్ట, మూల, శ్రవణము, శతభిషము."
    },
    {
        id:"Fifteen",
        name:"స్వాతి",
        desc:"భరణి, మృగశిర, పునర్వసు, పుష్యమి, పుబ్బ (పూర్వఫల్గుణి), హస్త, చిత్త, అనూరాధ, మూల, పూర్వాషాఢ, శ్రవణము, ధనిష్ఠ, పూర్వాభాద్ర."
    },
    {
        id:"Sixteen",
        name:"విశాఖ",
        desc:"భరణి, మృగశిర, ఆర్ద్ర, పునర్వసు, పుష్యమి, పుబ్బ (పూర్వఫల్గుణి), చిత్త, జ్యేష్ట, ధనిష్ఠ, శతభిషము, పూర్వాభాద్ర 1 2 3."
    },
    {
        id:"Seventeen",
        name:"అనురాధ",
        desc:"అశ్వని, కృత్తిక, రోహిణి, పునర్వసు, ఆశ్లేష, మఖ, ఉత్తర (ఉత్తరఫల్గుణి), హస్త, స్వాతి, జ్యేష్ట, ఉత్తరాషాఢ, శ్రవణము, శతభిషము, పూర్వాభాద్ర, రేవతి."
    },
    {
        id:"Eighteen",
        name:"జ్యేష్ట",
        desc:"రోహిణి, మృగశిర 1, 2 , పుష్యమి, ఆశ్లేష, మఖ, పుబ్బ (పూర్వఫల్గుణి),చిత్త 3 ,4, విశాఖ 1, 2, 3, అనూరాధ, శ్రవణము, ధనిష్ఠ, ఉత్తరాభాద్ర, రేవతి."
    },
    {
        id:"Ninteen",
        name:"మూల",
        desc:"భరణి, కృత్తిక, పుబ్బ (పూర్వఫల్గుణి), చిత్త, స్వాతి, పూర్వాషాఢ, ధనిష్ఠ, శతభిషము, ఉత్తరాభాద్ర, రేవతి."
    },
    {
        id:"Twenty",
        name:"పూర్వాషాడ",
        desc:"అశ్వని, ఆర్ద్ర, పునర్వసు,మఖ, ఉత్తర (ఉత్తరఫల్గుణి), హస్త, స్వాతి, విశాఖ, జ్యేష్ట, మూల, ఉత్తరాషాఢ, శ్రవణము, శతభిషము, పూర్వాభాద్ర, రేవతి."
    },
    {
        id:"TwentyOne",
        name:"ఉత్తరాషాడ",
        desc:"అశ్వని, భరణి, పుష్యమి, పుబ్బ (పూర్వఫల్గుణి), హస్త, అనూరాధ, పూర్వాషాఢ, పూర్వాభాద్ర, ఉత్తరాభాద్ర."
    },
    {
        id:"TwentyTwo",
        name:"శ్రవణం",
        desc:"భరణి, కృత్తిక, మృగశిర 1, 2, పుబ్బ (పూర్వఫల్గుణి), ఉత్తర 2, 3, 4, (ఉత్తరఫల్గుణి),చిత్త, స్వాతి, అనూరాధ, జ్యేష్ట, పూర్వాషాఢ, శ్రవణము, ధనిష్ఠ, శతభిషము, ఉత్తరాభాద్ర, రేవతి."
    },
    {
        id:"TwentyThree",
        name:"ఉత్తర",
        desc:"sadasdasdasds"
    },
    {
        id:"TwentyFour",
        name:"ధనిష్ఠ",
        desc:"కృత్తిక, రోహిణి, మఖ, స్వాతి, విశాఖ, జ్యేష్ట, మూల, శ్రవణము, శతభిషము, పూర్వాభాద్ర."
    },
    {
        id:"TwentyFive",
        name:"శతభిషం",
        desc:"భరణి, రోహిణి, మృగశిర, మఖ, చిత్త, విశాఖ, అనూరాధ, మూల, పూర్వాషాఢ, ధనిష్ఠ, ఉత్తరాభాద్ర."
    },
    {
        id:"TwentySix",
        name:"పూర్వాభాద్ర",
        desc:"మృగశిర, ఆర్ద్ర, పుష్యమి, పుబ్బ (పూర్వఫల్గుణి), స్వాతి, అనూరాధ, పూర్వాషాఢ, ఉత్తరాషాఢ, ఉత్తరాభాద్ర."
    },
    {
        id:"TwentySeven",
        name:"ఉత్తరాభాద్ర",
        desc:"అశ్వని, కృత్తిక, రోహిణి, ఆర్ద్ర, పునర్వసు, ఆశ్లేష, ఉత్తర (ఉత్తరఫల్గుణి), హస్త, జ్యేష్ట, మూల, ఉత్తరాషాఢ, శ్రవణము, శతభిషము, పూర్వాభాద్ర, రేవతి."
    },
    {
        id:"TwentyEight",
        name:"రేవతి",
        desc:"అశ్వని, భరణి, మృగశిర,పునర్వసు, పుష్యమి,హస్త, అనూరాధ, జ్యేష్ట, మూల, పూర్వాషాఢ, శ్రవణము, ఉత్తరాభాద్ర."
    }
]

export default data;